export const microlessonsLibraryText = {
  title: 'Microlessons',
  select: 'Select',
  lessonCopied: 'Lesson copied successfully',
};
